module.exports = __webpack_public_path__ + "img/foodworks.5b715e5d.png";